import "@fontsource-variable/plus-jakarta-sans";
import { createTokenFallback } from "../../utilities/tokenFallback.js";
import { getLensPresets } from "./getLensPresets.js";
import { getLensThemeComponents } from "./getLensThemeComponents.js";
import { createBreakpointOptions } from "./styles/breakpoints.js";
import { createPaletteOptions } from "./styles/palette.js";
import { createShadows } from "./styles/shadows.js";
import { createShape } from "./styles/shape.js";
import { createTypographyOptions } from "./styles/typography.js";
export const getLensThemeOptions = (tokens, atlasTokens) => {
    const themeOptions = {
        atlasThemeName: "lens",
        shadows: createShadows(tokens),
        palette: createPaletteOptions(tokens),
        typography: createTypographyOptions(tokens),
        shape: createShape(tokens),
        components: getLensThemeComponents(tokens),
        tokens: createTokenFallback(tokens, atlasTokens, (path) => {
            var _a, _b;
            if (process.env.NODE_ENV !== "production") {
                const fullPath = path.join(".");
                const callStack = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split("\n").slice(2);
                const reactComponent = (_b = callStack === null || callStack === void 0 ? void 0 : callStack.find((line) => line.includes(".tsx:"))) === null || _b === void 0 ? void 0 : _b.trim();
                console.warn(`[@diligentcorp/atlas-theme-mui]: Token at \`${fullPath}\` not defined in the Lens theme.\n` +
                    `Please migrate this token usage to the Lens theme. Using Atlas theme token as fallback. \n` +
                    `${reactComponent ? `Called ${reactComponent}` : ""}`);
            }
        }),
        presets: getLensPresets(tokens),
        breakpoints: createBreakpointOptions(tokens),
    };
    return themeOptions;
};
//# sourceMappingURL=getLensThemeOptions.js.map